/**
 * @generated SignedSource<<f2dd53631d7ad73eba43594542314916>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BuildState = "deleted" | "finished" | "queued" | "running" | "unknown";
import { FragmentRefs } from "relay-runtime";
export type useRunningBuildUpdaterRelayFragment$data = {
  readonly id: string;
  readonly rawId: number | null;
  readonly state: BuildState | null;
  readonly " $fragmentType": "useRunningBuildUpdaterRelayFragment";
};
export type useRunningBuildUpdaterRelayFragment$key = {
  readonly " $data"?: useRunningBuildUpdaterRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRunningBuildUpdaterRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useRunningBuildUpdaterRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    }
  ],
  "type": "Build",
  "abstractKey": null
};

(node as any).hash = "5be35fa0d4396e2d1f4358564b060cea";

export default node;
